// import React, { useEffect, useState } from "react";
// import LockIcon from "@material-ui/icons/Lock";
// import { makeStyles } from "@material-ui/core";
// import { useDispatch, useSelector } from "react-redux";
// import { addLogIn } from "../../signIn/signIn.action";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import { checkUserSessionAction } from "../../signIn/signIn.action";
// import axios from "axios"; // <-- Add this import

// export default function Login() {
//     // const classes = useStyles();
//     // const history = useHistory();
//     // const dispatch = useDispatch();
//     // const [password, setPassword] = useState("");
//     // const { isAuthenticated, error, loginLoading } = useSelector((state) => state.LoginSlicer || {});

//     // const handlePasswordChange = (event) => {
//     //     setPassword(event.target.value);
//     // };

//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();
//     //     try {
//     //         // Fix double slash in URL
//     //         const res = await axios.post("http://localhost:8000/api/v1/web/login", { password, isUser: true });
//     //         // Log the full response to check if API is being called properly
//     //         console.log("API response:", res.data);
//     //         // Check for success in response (adjust as per your backend response structure)
//     //         if (res && (res.success || res.token || res.status === 'success')) {
//     //             history.push("/investment");
//     //             localStorage.setItem("AdminHeaven", res.token);
//     //         } 
//     //     } catch (err) {
//     //         console.error("API error:", err);
//     //         alert(err.response?.data?.message || "Incorrect password");
//     //     }
//     // };

//     // // const handleSubmit = async (e) => {
//     // //     e.preventDefault();
//     // //     const payload = {
//     // //         password,
//     // //     };

//     // //     try {
//     // //         const result = await dispatch(addLogIn(payload));

//     // //         // Check if login was successful based on the result
//     // //         if (result.payload && result.payload.token) {
//     // //             history.push("/investment");
//     // //         }
//     // //     } catch (error) {
//     // //         console.error("Login failed", error);
//     // //     }
//     // // };

//     // useEffect(() => {
//     //     // Check for token and authentication on component mount
//     //     const token = localStorage.getItem("AdminHeaven");

//     //     if (token) {
//     //         // Verify the session when the component loads
//     //         dispatch(checkUserSessionAction())
//     //             .then((result) => {
//     //                 if (result.payload) {
//     //                     history.push("/investment");
//     //                 }
//     //             })
//     //             .catch(() => {
//     //                 // If session check fails, remove token and stay on login page
//     //                 localStorage.removeItem("AdminHeaven");
//     //             });
//     //     }
//     // }, [dispatch, history]);
//  const classes = useStyles();
//     const history = useHistory();
//     const dispatch = useDispatch();
//     const [password, setPassword] = useState("");
//     const { isAuthenticated } = useSelector((state) => state.LoginSlicer || {});


//     const handlePasswordChange = (event) => {
//         setPassword(event.target.value);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const payload = {
//             password,
//         };
//         await dispatch(addLogIn(payload));
//         setPassword("");
//     };

//     useEffect(() => {
//         if (isAuthenticated) {
//             // return <Redirect to={"/investments"} />;
//             history.push("/investment");
//         }
//     }, [isAuthenticated, history]);

//     return (
//         <section className={classes.main}>
//             <div className={classes.dataDev}>
//                 <div>
//                     <LockIcon className={classes.IconLock} />
//                 </div>
//                 <div>
//                     <p className={classes.para}>You need a password to view this page.</p>
//                 </div>
//                 {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
//                 <form onSubmit={handleSubmit}>
//                     <div>
//                         <input
//                             className={classes.inputLogin}
//                             type="password"
//                             value={password}
//                             onChange={handlePasswordChange}
//                             placeholder="Enter password"
//                         />
//                         <div>
//                             <button
//                                 type="submit"
//                                 className={classes.btnLogin}
//                                 disabled={loginLoading}
//                             >
//                                 {loginLoading ? 'SIGNING IN...' : 'SUBMIT'}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </section>
//     );
// }
// const useStyles = makeStyles((theme) => ({
//     main: {
//         backgroundColor: "#ececec",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//     },
//     dataDev: {
//         width: 400,
//         margin: "auto",
//         textAlign: "center",
//         padding: 0,

//         [theme.breakpoints.down("xs")]: {
//             width: "100%",
//             padding: "30px",
//         },
//     },
//     para: {
//         paddingTop: 5,
//         color: "#727272",
//     },
//     IconLock: {
//         color: "#727272",
//     },
//     inputLogin: {
//         width: "100%",
//         padding: "  8px",
//         borderRadius: 5,
//         color: "#727272",
//     },
//     btnLogin: {
//         marginTop: 10,
//         backgroundColor: "#494949",
//         border: "none",
//         color: "#fff",
//         cursor: "pointer",
//         fontWeight: "100",
//         width: "100%",
//         height: "42px",
//         textTransform: "uppercase",
//     },
// }));

import React, { useEffect, useState } from "react";
import LockIcon from "@material-ui/icons/Lock";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { addLogIn, checkUserSessionAction } from "../../signIn/signIn.action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

 
export default function Login() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [password, setPassword] = useState("");
    const loginState = useSelector((state) => state.loginSlicer || {});
    const {
        isAuthenticated = false,
        error = "",
        loginLoading = false,
    } = loginState;
 
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            password,
        };
       
        try {
            const result = await dispatch(addLogIn(payload));
           
            // Check if login was successful based on the result
            if (result.payload && result.payload.token) {
                history.push("/investment");
            }
        } catch (error) {
            console.error("Login failed", error);
        }
    };
 
    useEffect(() => {
        // Check for token and authentication on component mount
        const token = localStorage.getItem("AdminHeaven");
       
        if (token) {
            // Verify the session when the component loads
            dispatch(checkUserSessionAction())
                .then((result) => {
                    if (result.payload) {
                        history.push("/investment");
                    }
                })
                .catch(() => {
                    // If session check fails, remove token and stay on login page
                    localStorage.removeItem("AdminHeaven");
                });
        }
    }, [dispatch, history]);

    useEffect(() => {
        if (isAuthenticated) {
            history.push("/investment");
        }
    }, [isAuthenticated, history]);
 
    return (
        <section className={classes.main}>
            <div className={classes.dataDev}>
                <div>
                    <LockIcon className={classes.IconLock} />
                </div>
                <div>
                    <p className={classes.para}>You need a password to view this page.</p>
                </div>
                {typeof error === "string" && error.trim().length > 0 && (
                    <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>
                )}
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            className={classes.inputLogin}
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            placeholder="Enter password"
                        />
                        <div>
                            <button
                                type="submit"
                                className={classes.btnLogin}
                                disabled={loginLoading}
                            >
                                {loginLoading ? 'SIGNING IN...' : 'SUBMIT'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
}
const useStyles = makeStyles((theme) => ({
    main: {
        backgroundColor: "#ececec",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    dataDev: {
        width: 400,
        margin: "auto",
        textAlign: "center",
        padding: 0,
 
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            padding: "30px",
        },
    },
    para: {
        paddingTop: 5,
        color: "#727272",
    },
    IconLock: {
        color: "#727272",
    },
    inputLogin: {
        width: "100%",
        padding: "  8px",
        borderRadius: 5,
        color: "#727272",
    },
    btnLogin: {
        marginTop: 10,
        backgroundColor: "#494949",
        border: "none",
        color: "#fff",
        cursor: "pointer",
        fontWeight: "100",
        width: "100%",
        height: "42px",
        textTransform: "uppercase",
    },
}));